import React from 'react';
import PropTypes from 'prop-types';

const Pan = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.7556 7.82812H6.89395C6.2174 7.82812 5.66895 8.37658 5.66895 9.05313V9.06479C5.66895 9.74134 6.2174 10.2898 6.89395 10.2898H10.7556C11.4322 10.2898 11.9806 9.74134 11.9806 9.06479V9.05313C11.9806 8.37658 11.4322 7.82812 10.7556 7.82812Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M10.7556 13.125H6.89395C6.2174 13.125 5.66895 13.6735 5.66895 14.35V14.3617C5.66895 15.0382 6.2174 15.5867 6.89395 15.5867H10.7556C11.4322 15.5867 11.9806 15.0382 11.9806 14.3617V14.35C11.9806 13.6735 11.4322 13.125 10.7556 13.125Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M15.9126 9.49596C15.9309 9.91146 16.0708 10.3124 16.3149 10.6491C16.5591 10.9858 16.8967 11.2434 17.286 11.3899C17.6752 11.5364 18.0989 11.5653 18.5045 11.4732C18.91 11.381 19.2796 11.1718 19.5673 10.8714C19.8549 10.5711 20.0481 10.1929 20.1228 9.78374C20.1974 9.3746 20.1503 8.95255 19.9872 8.56997C19.8241 8.18739 19.5522 7.86112 19.2053 7.63168C18.8585 7.40223 18.4518 7.2797 18.036 7.2793C17.751 7.28536 17.47 7.34751 17.209 7.4622C16.948 7.5769 16.7122 7.74188 16.5151 7.94773C16.3179 8.15358 16.1632 8.39626 16.0598 8.66191C15.9564 8.92756 15.9064 9.21098 15.9126 9.49596Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M20.8854 15.5864L17.4426 17.064C17.344 17.1041 17.2599 17.1713 17.201 17.2572C17.142 17.3431 17.1108 17.4439 17.1113 17.5469V19.7971C17.1177 20.925 17.4936 22.0221 18.1856 22.9325C18.8777 23.8428 19.8505 24.5199 20.9657 24.8674C21.0741 24.8962 21.1885 24.8962 21.2969 24.8674C22.4046 24.5133 23.3687 23.8333 24.0531 22.9236C24.7374 22.0138 25.1075 20.9202 25.1111 19.7971V17.5759C25.1144 17.4723 25.0843 17.3704 25.025 17.2839C24.9657 17.1975 24.8801 17.1308 24.7799 17.093L21.3371 15.6154C21.2676 15.5818 21.1918 15.5619 21.1143 15.5569C21.0367 15.5519 20.9589 15.562 20.8854 15.5864ZM20.2229 22.3468L18.4463 20.6373L19.0686 20.0289L20.2229 21.1395L23.1538 18.3195L23.7862 18.9183L20.2229 22.3468Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M16.3332 15.0973L20.1599 13.3939L20.5099 13.2773C19.7045 12.9725 18.851 12.8144 17.9899 12.8106C16.971 12.8071 15.9637 13.0261 15.0382 13.4523C14.6457 13.6289 14.3131 13.9161 14.0811 14.2787C13.849 14.6412 13.7276 15.0635 13.7315 15.4939C13.7315 16.0773 13.7315 16.1239 14.3032 16.1356H15.2365C15.4769 15.6775 15.8627 15.3122 16.3332 15.0973Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M14.9687 19.8336V19.1919H3.8504V4.66689H24.1504V14.3036L25.9587 15.1086C26.2352 15.2397 26.4846 15.4218 26.6937 15.6452V4.66689C26.7063 3.97883 26.4457 3.31385 25.969 2.8175C25.4923 2.32115 24.8384 2.03387 24.1504 2.01855H3.8504C3.16241 2.03387 2.5085 2.32115 2.03183 2.8175C1.55516 3.31385 1.29456 3.97883 1.30707 4.66689V19.1802C1.29767 19.8663 1.55966 20.5283 2.03599 21.0221C2.51233 21.5159 3.16446 21.8016 3.8504 21.8169H15.2604C15.0756 21.1717 14.9775 20.5047 14.9687 19.8336Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

Pan.propTypes = {
  fill: PropTypes.string,
};

export default Pan;
